module.exports = __webpack_public_path__ + "img/epc-track.d24ba073.svg";